export const emitter = mitt();

export class global_params {
  static regions = [];
  static region_indexes = {};
  static region_boundaries = null;
  static cities = [];
  static city_indexes = {};
  static districts = [];
  static district_indexes = {};
  static district_boundaries = null;
  static ksa_geo_json = {
    "type":"FeatureCollection","features":[{"type":"Feature","properties":{},"geometry":{"type":"Polygon","coordinates":[[[-126.131845,-57.136239],[-126.131845,81.403423],[206.30569,81.403423],[206.30569,-57.136239],[-126.131845,-57.136239]], [[42.757433,16.405129],[42.767303,16.398015],[42.797653,16.394656],[42.831024,16.3743],[42.963409,16.397093],[42.949402,16.449783],[42.95668,16.491728],[42.998978,16.512993],[43.128754,16.516877],[43.153954,16.632771],[43.149765,16.659678],[43.22406,16.635863],[43.244797,16.638823],[43.237759,16.70549],[43.220387,16.70812],[43.238583,16.732846],[43.256916,16.732222],[43.284279,16.745932],[43.26622,16.763618],[43.263268,16.778772],[43.274117,16.797343],[43.254684,16.810654],[43.235287,16.812133],[43.225159,16.840526],[43.202843,16.857875],[43.18523,16.85873],[43.17881,16.872463],[43.157352,16.883896],[43.15052,16.902555],[43.144581,16.911457],[43.150383,16.92187],[43.173214,16.925877],[43.179943,16.933628],[43.198551,16.941149],[43.19965,16.958489],[43.184097,16.966305],[43.187565,16.983052],[43.18293,16.994018],[43.18499,17.009219],[43.202465,17.006035],[43.228111,17.005969],[43.244865,17.021793],[43.247818,17.041128],[43.230995,17.079824],[43.210361,17.086125],[43.188217,17.104666],[43.167618,17.097841],[43.166931,17.115166],[43.184921,17.128028],[43.176476,17.170708],[43.198792,17.186256],[43.224129,17.209575],[43.207031,17.242465],[43.208061,17.255613],[43.258564,17.272924],[43.271507,17.284988],[43.305642,17.28725],[43.316487,17.294101],[43.34203,17.299608],[43.33434,17.330549],[43.285725,17.359388],[43.237111,17.384814],[43.25359,17.400278],[43.232167,17.426485],[43.262379,17.456881],[43.249333,17.478954],[43.264439,17.485765],[43.354802,17.547579],[43.376225,17.536579],[43.419359,17.545451],[43.668749,17.34841],[43.803881,17.321143],[43.958788,17.311703],[44.202684,17.37777],[44.360887,17.400835],[44.564135,17.383012],[45.203539,17.39769],[45.390307,17.303312],[46.373583,17.195243],[46.73723,17.244564],[46.998705,16.909552],[47.183275,16.921114],[47.488695,17.093411],[47.632891,17.436476],[48.206652,18.146504],[49.128405,18.588071],[50.794756,18.764224],[52.008745,18.977338],[55.029488,19.955278],[55.694126,22.006976],[55.210728,22.74047],[55.122837,22.66547],[52.591587,22.95814],[51.607761,24.14149],[51.612156,24.267748],[51.464939,24.409889],[51.607761,24.569856],[51.603367,24.711656],[51.368259,24.649763],[51.291355,24.53588],[51.091404,24.511891],[50.933201,24.58784],[50.834324,24.773518],[50.611301,25.197237],[50.527805,25.476753],[50.193821,25.967675],[50.32291,26.301048],[50.265781,26.650159],[49.824131,27.02659],[49.761509,27.300279],[49.089146,27.785388],[48.548069,28.5563],[47.732883,28.571256],[47.496128,29.063612],[46.611729,29.126972],[46.421116,29.093377],[44.736912,29.224336],[42.093601,31.152883],[41.447605,31.40452],[40.421482,31.976629],[39.187717,32.174915],[38.987217,32.017159],[36.96793,31.518381],[37.961094,30.503354],[37.639195,30.352731],[37.483189,30.02844],[36.767429,29.898996],[36.374119,29.429312],[36.070896,29.214747],[34.900852,29.393901],[34.725071,28.652272],[34.534458,28.075615],[34.591587,27.988338],[35.099155,28.003859],[35.66605,27.268058],[36.226353,26.429015],[36.513645,25.95434],[36.794895,25.534759],[37.128879,25.105746],[37.133274,24.763542],[37.462864,24.223673],[37.93198,24.048721],[38.360447,23.747891],[38.707615,23.084533],[39.021824,22.385381],[38.800449,21.899475],[39.050938,21.188253],[39.413487,20.621731],[39.690891,20.27946],[40.209446,20.040192],[40.670872,19.572989],[40.92136,19.135568],[41.127388,18.507219],[41.762913,17.610254],[42.123264,17.377639],[42.428135,16.779035],[42.757433,16.405129]]]}}]
  };
  static months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  static ages = {
    1	 :  "New",
    2	 :  "LessThanYear",
    3	 :  "OneYear",
    4	 :  "TwoYears",
    5	 :  "ThreeYears",
    6	 :  "FourYears",
    7	 :  "FiveYears",
    8	 :  "SixYears",
    9	 :  "SevenYears",
    10 :  "EightYears",
    11 :  "NineYears",
    12 :  "TenYears",
    13 :  "MoreThenTenYears",
  }
  static legend_icons = {
    "Apartment": "/assets/maalek/images/map-icons/apartment-icon-l.png",
    "Studio": "/assets/maalek/images/map-icons/apartment-icon-l.png",
    "Room": "/assets/maalek/images/map-icons/apartment-icon-l.png",
    "Floor": "/assets/maalek/images/map-icons/floor-icon-l.png",
    "Town House": "/assets/maalek/images/map-icons/floor-icon-l.png",
    "Penthouse": "/assets/maalek/images/map-icons/floor-icon-l.png",
    "Villa": "/assets/maalek/images/map-icons/villa-icon-l.png",
    "School": "/assets/maalek/images/map-icons/villa-icon-l.png",
    "HospitalOrHealthCenter": "/assets/maalek/images/map-icons/villa-icon-l.png",
    "Building": "/assets/maalek/images/map-icons/building-icon-l.png",
    "Compound": "/assets/maalek/images/map-icons/building-icon-l.png",
    "Tower": "/assets/maalek/images/map-icons/building-icon-l.png",
    "Hotel": "/assets/maalek/images/map-icons/building-icon-l.png",
    "Chalet": "/assets/maalek/images/map-icons/chalet-icon-l.png",
    "RestHouse": "/assets/maalek/images/map-icons/chalet-icon-l.png",
    "Farm": "/assets/maalek/images/map-icons/farm-icon-l.png",
    "Land": "/assets/maalek/images/map-icons/land-icon-l.png",
    "TelecomTower": "/assets/maalek/images/map-icons/land-icon-l.png",
    "ElectricityStation": "/assets/maalek/images/map-icons/land-icon-l.png",
    "Teller": "/assets/maalek/images/map-icons/land-icon-l.png",
    "Shop": "/assets/maalek/images/map-icons/shop-icon-l.png",
    "Booth": "/assets/maalek/images/map-icons/shop-icon-l.png",
    "RepairShop": "/assets/maalek/images/map-icons/shop-icon-l.png",
    "Office": "/assets/maalek/images/map-icons/shop-icon-l.png",
    "Warehouses": "/assets/maalek/images/map-icons/warehouse-icon-l.png",
    "Station": "/assets/maalek/images/map-icons/warehouse-icon-l.png",
    "Factory": "/assets/maalek/images/map-icons/warehouse-icon-l.png",
    "CarParking": "/assets/maalek/images/map-icons/warehouse-icon-l.png",
    "Cinema": "/assets/maalek/images/map-icons/warehouse-icon-l.png",
    "Exhibition": "/assets/maalek/images/map-icons/warehouse-icon-l.png",
  };
  static map_icons = {
    "Mashro": "/assets/maalek/images/map-icons/default-icon-d.png",
    "Default": {
      "Rent": "/assets/maalek/images/map-icons/default-icon-g.png",
      "Sale": "/assets/maalek/images/map-icons/default-icon-b.png",
      "Auction": "/assets/maalek/images/map-icons/default-icon-o.png",
    },
    "Apartment": {
      "Rent": "/assets/maalek/images/map-icons/apartment-icon-g.png",
      "Sale": "/assets/maalek/images/map-icons/apartment-icon-b.png",
      "Auction": "/assets/maalek/images/map-icons/apartment-icon-o.png",
    },
    "Studio": {
      "Rent": "/assets/maalek/images/map-icons/apartment-icon-g.png",
      "Sale": "/assets/maalek/images/map-icons/apartment-icon-b.png",
      "Auction": "/assets/maalek/images/map-icons/apartment-icon-o.png",
    },
    "Room": {
      "Rent": "/assets/maalek/images/map-icons/apartment-icon-g.png",
      "Sale": "/assets/maalek/images/map-icons/apartment-icon-b.png",
      "Auction": "/assets/maalek/images/map-icons/apartment-icon-o.png",
    },
    "Floor": {
      "Rent": "/assets/maalek/images/map-icons/floor-icon-g.png",
      "Sale": "/assets/maalek/images/map-icons/floor-icon-b.png",
      "Auction": "/assets/maalek/images/map-icons/floor-icon-o.png",
    },
    "Town House": {
      "Rent": "/assets/maalek/images/map-icons/floor-icon-g.png",
      "Sale": "/assets/maalek/images/map-icons/floor-icon-b.png",
      "Auction": "/assets/maalek/images/map-icons/floor-icon-o.png",
    },
    "Penthouse": {
      "Rent": "/assets/maalek/images/map-icons/floor-icon-g.png",
      "Sale": "/assets/maalek/images/map-icons/floor-icon-b.png",
      "Auction": "/assets/maalek/images/map-icons/floor-icon-o.png",
    },
    "Villa": {
      "Rent": "/assets/maalek/images/map-icons/villa-icon-g.png",
      "Sale": "/assets/maalek/images/map-icons/villa-icon-b.png",
      "Auction": "/assets/maalek/images/map-icons/villa-icon-o.png",
    },
    "School": {
      "Rent": "/assets/maalek/images/map-icons/villa-icon-g.png",
      "Sale": "/assets/maalek/images/map-icons/villa-icon-b.png",
      "Auction": "/assets/maalek/images/map-icons/villa-icon-o.png",
    },
    "HospitalOrHealthCenter": {
      "Rent": "/assets/maalek/images/map-icons/villa-icon-g.png",
      "Sale": "/assets/maalek/images/map-icons/villa-icon-b.png",
      "Auction": "/assets/maalek/images/map-icons/villa-icon-o.png",
    },
    "House": {
      "Rent": "/assets/maalek/images/map-icons/house-icon-g.png",
      "Sale": "/assets/maalek/images/map-icons/house-icon-b.png",
      "Auction": "/assets/maalek/images/map-icons/house-icon-o.png",
    },
    "Building": {
      "Rent": "/assets/maalek/images/map-icons/building-icon-g.png",
      "Sale": "/assets/maalek/images/map-icons/building-icon-b.png",
      "Auction": "/assets/maalek/images/map-icons/building-icon-o.png",
    },
    "Compound": {
      "Rent": "/assets/maalek/images/map-icons/building-icon-g.png",
      "Sale": "/assets/maalek/images/map-icons/building-icon-b.png",
      "Auction": "/assets/maalek/images/map-icons/building-icon-o.png",
    },
    "Tower": {
      "Rent": "/assets/maalek/images/map-icons/building-icon-g.png",
      "Sale": "/assets/maalek/images/map-icons/building-icon-b.png",
      "Auction": "/assets/maalek/images/map-icons/building-icon-o.png",
    },
    "Hotel": {
      "Rent": "/assets/maalek/images/map-icons/building-icon-g.png",
      "Sale": "/assets/maalek/images/map-icons/building-icon-b.png",
      "Auction": "/assets/maalek/images/map-icons/building-icon-o.png",
    },
    "Chalet": {
      "Rent": "/assets/maalek/images/map-icons/chalet-icon-g.png",
      "Sale": "/assets/maalek/images/map-icons/chalet-icon-b.png",
      "Auction": "/assets/maalek/images/map-icons/chalet-icon-o.png",
    },
    "RestHouse": {
      "Rent": "/assets/maalek/images/map-icons/chalet-icon-g.png",
      "Sale": "/assets/maalek/images/map-icons/chalet-icon-b.png",
      "Auction": "/assets/maalek/images/map-icons/chalet-icon-o.png",
    },
    "Camp": {
      "Rent": "/assets/maalek/images/map-icons/camp-icon-g.png",
      "Sale": "/assets/maalek/images/map-icons/camp-icon-b.png",
      "Auction": "/assets/maalek/images/map-icons/camp-icon-o.png",
    },
    "Farm": {
      "Rent": "/assets/maalek/images/map-icons/farm-icon-g.png",
      "Sale": "/assets/maalek/images/map-icons/farm-icon-b.png",
      "Auction": "/assets/maalek/images/map-icons/farm-icon-o.png",
    },
    "Land": {
      "Rent": "/assets/maalek/images/map-icons/land-icon-g.png",
      "Sale": "/assets/maalek/images/map-icons/land-icon-b.png",
      "Auction": "/assets/maalek/images/map-icons/land-icon-o.png",
    },
    "TelecomTower": {
      "Rent": "/assets/maalek/images/map-icons/land-icon-g.png",
      "Sale": "/assets/maalek/images/map-icons/land-icon-b.png",
      "Auction": "/assets/maalek/images/map-icons/land-icon-o.png",
    },
    "ElectricityStation": {
      "Rent": "/assets/maalek/images/map-icons/land-icon-g.png",
      "Sale": "/assets/maalek/images/map-icons/land-icon-b.png",
      "Auction": "/assets/maalek/images/map-icons/land-icon-o.png",
    },
    "Teller": {
      "Rent": "/assets/maalek/images/map-icons/land-icon-g.png",
      "Sale": "/assets/maalek/images/map-icons/land-icon-b.png",
      "Auction": "/assets/maalek/images/map-icons/land-icon-o.png",
    },
    "Shop": {
      "Rent": "/assets/maalek/images/map-icons/shop-icon-g.png",
      "Sale": "/assets/maalek/images/map-icons/shop-icon-b.png",
      "Auction": "/assets/maalek/images/map-icons/shop-icon-o.png",
    },
    "Booth": {
      "Rent": "/assets/maalek/images/map-icons/shop-icon-g.png",
      "Sale": "/assets/maalek/images/map-icons/shop-icon-b.png",
      "Auction": "/assets/maalek/images/map-icons/shop-icon-o.png",
    },
    "RepairShop": {
      "Rent": "/assets/maalek/images/map-icons/shop-icon-g.png",
      "Sale": "/assets/maalek/images/map-icons/shop-icon-b.png",
      "Auction": "/assets/maalek/images/map-icons/shop-icon-o.png",
    },
    "Office": {
      "Rent": "/assets/maalek/images/map-icons/shop-icon-g.png",
      "Sale": "/assets/maalek/images/map-icons/shop-icon-b.png",
      "Auction": "/assets/maalek/images/map-icons/shop-icon-o.png",
    },
    "Warehouses": {
      "Rent": "/assets/maalek/images/map-icons/warehouse-icon-g.png",
      "Sale": "/assets/maalek/images/map-icons/warehouse-icon-b.png",
      "Auction": "/assets/maalek/images/map-icons/warehouse-icon-o.png",
    },
    "Station": {
      "Rent": "/assets/maalek/images/map-icons/warehouse-icon-g.png",
      "Sale": "/assets/maalek/images/map-icons/warehouse-icon-b.png",
      "Auction": "/assets/maalek/images/map-icons/warehouse-icon-o.png",
    },
    "Factory": {
      "Rent": "/assets/maalek/images/map-icons/warehouse-icon-g.png",
      "Sale": "/assets/maalek/images/map-icons/warehouse-icon-b.png",
      "Auction": "/assets/maalek/images/map-icons/warehouse-icon-o.png",
    },
    "CarParking": {
      "Rent": "/assets/maalek/images/map-icons/warehouse-icon-g.png",
      "Sale": "/assets/maalek/images/map-icons/warehouse-icon-b.png",
      "Auction": "/assets/maalek/images/map-icons/warehouse-icon-o.png",
    },
    "Cinema": {
      "Rent": "/assets/maalek/images/map-icons/warehouse-icon-g.png",
      "Sale": "/assets/maalek/images/map-icons/warehouse-icon-b.png",
      "Auction": "/assets/maalek/images/map-icons/warehouse-icon-o.png",
    },
    "Exhibition": {
      "Rent": "/assets/maalek/images/map-icons/warehouse-icon-g.png",
      "Sale": "/assets/maalek/images/map-icons/warehouse-icon-b.png",
      "Auction": "/assets/maalek/images/map-icons/warehouse-icon-o.png",
    },
  };
  static ad_type_colors = {
    Rent: "#4CBB17",
    Sale: "#4d89ff",
    Auction: "#ff9000",
  };

  constructor() {}
  static async get_regions(with_bounds=true) {
    if (global_params.regions.length > 0) return global_params.regions;
    try {
      emitter.emit("show-full-loading");
      let params = {
        'with_bounds' : with_bounds
      };
      let res = await $.ajax({
        headers: { "X-Frappe-CSRF-Token": this.csrf_token },
        url: "/api/method/maalek.api.get_regions",
        type: "GET",
        data: params, //for GET request
        // data: JSON.stringify(params) //for POST request
      });
      for (let index = 0; index < res.message.length; index++) {
        var region = res.message[index];
        global_params.regions.push(region);
        global_params.region_indexes[region.region_id] = index;
      }
      // emitter.emit("update-property-form");
      emitter.emit("hide-full-loading");
      return global_params.regions;
    } catch (error) {
      console.log("error");
      console.log(error);
      emitter.emit("hide-full-loading");
      return [];
    }
  }
  static get_region(region_id) {
    let region = global_params.regions[global_params.region_indexes[region_id]];
    if(region == undefined){
      region = global_params.regions[global_params.region_indexes["0"+region_id]];
    }
    return region;
  }
  static async get_cities(region_id = null) {
    // if(global_params.cities.length > 0)
    //   return global_params.cities
    global_params.cities = [];
    try {
      emitter.emit("show-full-loading");
      let params = {};
      if (region_id) {
        params["region_id"] = region_id;
      }
      let res = await $.ajax({
        headers: { "X-Frappe-CSRF-Token": this.csrf_token },
        url: "/api/method/maalek.api.get_cities",
        type: "GET",
        data: params, //for GET request
        // data: JSON.stringify(params) //for POST request
      });
      for (let index = 0; index < res.message.length; index++) {
        var city = res.message[index];
        global_params.cities.push(city);
        global_params.city_indexes[city.city_id] = index;
      }
      // emitter.emit("update-property-form");
      emitter.emit("hide-full-loading");
      return global_params.cities;
    } catch (error) {
      console.log("error");
      console.log(error);
      emitter.emit("hide-full-loading");
      return [];
    }
  }
  static get_city(city_id) {
    let city = global_params.cities[global_params.city_indexes[city_id]];
    return city;
  }
  static async get_districts(city_id) {
    // if(global_params.districts.length > 0)
    //   return global_params.districts
    global_params.districts = [];
    try {
      emitter.emit("show-full-loading");
      let params = {};
      let res = await $.ajax({
        headers: { "X-Frappe-CSRF-Token": this.csrf_token },
        url: "/api/method/maalek.api.get_districts?city_id=" + city_id,
        type: "GET",
        data: params, //for GET request
        // data: JSON.stringify(params) //for POST request
      });
      for (let index = 0; index < res.message.length; index++) {
        var district = res.message[index];
        global_params.districts.push(district);
        global_params.district_indexes[district.district_id] = index;
        // console.log(district.center);
      }
      // emitter.emit("update-property-form");
      emitter.emit("hide-full-loading");
      return global_params.districts;
    } catch (error) {
      console.log("error");
      console.log(error);
      emitter.emit("hide-full-loading");
      return [];
    }
  }
  static get_district(district_id) {
    let district =
      global_params.districts[global_params.district_indexes[district_id]];
    return district;
  }
  static async get_region_boundaries(region_id) {
    global_params.region_boundaries = null;
    try {
      emitter.emit("show-full-loading");
      let params = {};
      let res = await $.ajax({
        headers: { "X-Frappe-CSRF-Token": this.csrf_token },
        url:
          "/api/method/maalek.api.get_region_boundaries?region_id=" + region_id,
        type: "GET",
        data: params, //for GET request
        // data: JSON.stringify(params) //for POST request
      });
      global_params.region_boundaries = res.message.boundaries;
      emitter.emit("hide-full-loading");
      if (res.message == "") return null;
      return res.message.boundaries;
    } catch (error) {
      console.log("error");
      console.log(error);
      emitter.emit("hide-full-loading");
      return null;
    }
  }
  static async get_district_boundaries(district_id) {
    global_params.district_boundaries = null;
    try {
      emitter.emit("show-full-loading");
      let params = {};
      let res = await $.ajax({
        headers: { "X-Frappe-CSRF-Token": this.csrf_token },
        url:
          "/api/method/maalek.api.get_district_boundaries?district_id=" +
          district_id,
        type: "GET",
        data: params, //for GET request
        // data: JSON.stringify(params) //for POST request
      });
      global_params.district_boundaries = res.message.boundaries;
      emitter.emit("hide-full-loading");
      if (res.message == "") return null;
      return res.message.boundaries;
    } catch (error) {
      console.log("error");
      console.log(error);
      emitter.emit("hide-full-loading");
      return null;
    }
  }
}

export class image_file {
  data = null;
  file = null;
  link = null;
  link_name = null;
  constructor(options = {}) {
    this.data = options.data || null;
    this.file = options.file || null;
    this.link = options.link || null;
    this.link_name = options.link_name || null;
  }
}

export class pdf_file {
  data = null;
  file = null;
  link = null;
  type = null;
  link_name = null;
  constructor(options = {}) {
    this.data = options.data || null;
    this.file = options.file || null;
    this.link = options.link || null;
    this.type = options.type || null;
    this.link_name = options.link_name || null;
  }
}
export const mashro_constants = {
  mashro_guarantee_types:["Electrical","Plumbing","Doors","Lighting","Structural","Windows","Switches","Sanitary"],
  mashro_property_types:[ "Land","Apartment","Villa","Floor","Building","Office","Chalet","Town House","Penthouse"]
}
// export const quick_cart = new cart_obj();
export const property_constants = {
  property_keys: [
    "Land",
    "Apartment",
    "Villa",
    "Shop",
    "Floor",
    "Building",
    "Office",
    "RestHouse",
    "Chalet",
    "Warehouses",
    "Studio",
    "Room",
    "Compound",
    "Tower",
    "Exhibition",
    "Booth",
    "Cinema",
    "Hotel",
    "CarParking",
    "RepairShop",
    "Teller",
    "Factory",
    "School",
    "HospitalOrHealthCenter",
    "ElectricityStation",
    "TelecomTower",
    "Station",
    "Farm",
  ],
  property_types: {
    "Apartment": [
      "video",
      "for_type",
      "location",
      "is_family",
      "is_furnished",
      "is_kitchen",
      "is_rooftop",
      "is_parking",
      "is_elevator",
      "is_air_conditioners",
      "is_private_entrance",
      "is_two_entrances",
      "is_inside_villa",
      "is_inside_building",
      "allow_whatsapp",
      "allow_call",
      "publish",
      "street_width",
      "no_bed",
      "size",
      "front",
      "side",
      "no_living",
      "no_bath",
      "floor_num",
      "age",
      "price_sqr_meter",
      "total_price",
      "region",
      "city",
      "district",
      "description",
    ],
    "Studio": [
      "video",
      "for_type",
      "location",
      "is_family",
      "is_furnished",
      "is_kitchen",
      "is_rooftop",
      "is_parking",
      "is_elevator",
      "is_air_conditioners",
      "is_private_entrance",
      "is_two_entrances",
      "is_inside_villa",
      "is_inside_building",
      "allow_whatsapp",
      "allow_call",
      "publish",
      "street_width",
      "no_bed",
      "size",
      "front",
      "side",
      "no_bath",
      "floor_num",
      "age",
      "price_sqr_meter",
      "total_price",
      "region",
      "city",
      "district",
      "description",
    ],
    "Room": [
      "video",
      "for_type",
      "location",
      "is_family",
      "is_furnished",
      "is_kitchen",
      "is_rooftop",
      "is_parking",
      "is_elevator",
      "is_air_conditioners",
      "is_private_entrance",
      "is_two_entrances",
      "is_inside_villa",
      "is_inside_building",
      "allow_whatsapp",
      "allow_call",
      "publish",
      "street_width",
      "size",
      "front",
      "side",
      "floor_num",
      "age",
      "price_sqr_meter",
      "total_price",
      "region",
      "city",
      "district",
      "description",
    ],
    "Floor": [
      "video",
      "for_type",
      "location",
      "is_family",
      "is_furnished",
      "is_kitchen",
      "is_rooftop",
      "is_parking",
      "is_elevator",
      "is_air_conditioners",
      "is_private_entrance",
      "is_two_entrances",
      "is_inside_villa",
      "is_inside_building",
      "allow_whatsapp",
      "allow_call",
      "publish",
      "street_width",
      "no_bed",
      "size",
      "front",
      "side",
      "no_living",
      "no_bath",
      "floor_num",
      "age",
      "price_sqr_meter",
      "total_price",
      "region",
      "city",
      "district",
      "description",
    ],
    "Villa": [
      "video",
      "location",
      "is_furnished",
      "is_kitchen",
      "is_rooftop",
      "is_parking",
      "is_elevator",
      "is_air_conditioners",
      "is_internal_stairs",
      "is_driver_room",
      "is_maid_room",
      "is_pool",
      "is_fire_room",
      "is_yard",
      "is_basement",
      "is_duplex",
      "allow_whatsapp",
      "allow_call",
      "publish",
      "street_width",
      "no_bed",
      "size",
      "front",
      "side",
      "no_living",
      "no_bath",
      "age",
      "price_sqr_meter",
      "total_price",
      "region",
      "city",
      "district",
      "description"
    ],
    "School": [
      "video",
      "location",
      "is_furnished",
      "is_kitchen",
      "is_rooftop",
      "is_parking",
      "is_elevator",
      "is_air_conditioners",
      "is_internal_stairs",
      "is_driver_room",
      "is_maid_room",
      "is_pool",
      "is_fire_room",
      "is_yard",
      "is_basement",
      "is_duplex",
      "allow_whatsapp",
      "allow_call",
      "publish",
      "street_width",
      "no_bed",
      "size",
      "front",
      "side",
      "no_bath",
      "age",
      "price_sqr_meter",
      "total_price",
      "region",
      "city",
      "district",
      "description"
    ],
    "HospitalOrHealthCenter": [
      "video",
      "location",
      "is_furnished",
      "is_kitchen",
      "is_rooftop",
      "is_parking",
      "is_elevator",
      "is_air_conditioners",
      "is_internal_stairs",
      "is_driver_room",
      "is_maid_room",
      "is_pool",
      "is_fire_room",
      "is_yard",
      "is_basement",
      "is_duplex",
      "allow_whatsapp",
      "allow_call",
      "publish",
      "street_width",
      "no_bed",
      "size",
      "front",
      "side",
      "no_bath",
      "age",
      "price_sqr_meter",
      "total_price",
      "region",
      "city",
      "district",
      "description"
    ],
    "Building": [
      "video",
      "location",
      "is_furnished",
      "allow_whatsapp",
      "allow_call",
      "publish",
      "is_parking",
      "is_elevator",
      "is_air_conditioners",
      "property_for",
      "street_width",
      "size",
      "front",
      "side",
      "age",
      "price_sqr_meter",
      "total_price",
      "region",
      "city",
      "district",
      "description",
      "no_apartment",
      "no_shop",
    ],
    "Compound": [
      "video",
      "location",
      "is_furnished",
      "allow_whatsapp",
      "allow_call",
      "publish",
      "is_parking",
      "property_for",
      "street_width",
      "size",
      "front",
      "side",
      "age",
      "price_sqr_meter",
      "total_price",
      "region",
      "city",
      "district",
      "description",
    ],
    "Tower": [
      "video",
      "location",
      "is_furnished",
      "allow_whatsapp",
      "allow_call",
      "publish",
      "is_parking",
      "is_elevator",
      "is_air_conditioners",
      "property_for",
      "street_width",
      "size",
      "front",
      "side",
      "age",
      "price_sqr_meter",
      "total_price",
      "region",
      "city",
      "district",
      "description",
      "no_apartment",
      "no_shop",
    ],
    "Hotel": [
      "video",
      "location",
      "is_furnished",
      "allow_whatsapp",
      "allow_call",
      "publish",
      "is_parking",
      "is_elevator",
      "is_air_conditioners",
      "property_for",
      "street_width",
      "size",
      "front",
      "side",
      "age",
      "price_sqr_meter",
      "total_price",
      "region",
      "city",
      "district",
      "description",
      "no_apartment",
      "no_shop",
    ],
    "RestHouse": [
      "video",
      "location",
      "is_kitchen",
      "is_pool",
      "is_fire_room",
      "is_football_area",
      "is_volleyball_area",
      "is_amusement_area",
      "is_female_section",
      "allow_whatsapp",
      "allow_call",
      "publish",
      "street_width",
      "no_bed",
      "size",
      "front",
      "side",
      "no_living",
      "no_bath",
      "age",
      "price_sqr_meter",
      "total_price",
      "region",
      "city",
      "district",
      "description",
    ],
    "Chalet": [
      "video",
      "location",
      "is_kitchen",
      "is_pool",
      "is_fire_room",
      "is_football_area",
      "is_volleyball_area",
      "is_amusement_area",
      "is_female_section",
      "allow_whatsapp",
      "allow_call",
      "publish",
      "street_width",
      "no_bed",
      "size",
      "front",
      "side",
      "no_living",
      "no_bath",
      "age",
      "price_sqr_meter",
      "total_price",
      "region",
      "city",
      "district",
      "description",
    ],
    "Farm": [
      "video",
      "location",
      "allow_whatsapp",
      "allow_call",
      "publish",
      "size",
      "front",
      "side",
      "price_sqr_meter",
      "total_price",
      "region",
      "city",
      "district",
      "description",
      "age",
    ],
    "Land": [
      "video",
      "location",
      "allow_whatsapp",
      "allow_call",
      "publish",
      "property_for",
      "street_width",
      "size",
      "front",
      "side",
      "price_sqr_meter",
      "total_price",
      "region",
      "city",
      "district",
      "description",
      "age",
    ],
    "Teller": [
      "video",
      "location",
      "allow_whatsapp",
      "allow_call",
      "publish",
      "property_for",
      "street_width",
      "size",
      "front",
      "side",
      "price_sqr_meter",
      "total_price",
      "region",
      "city",
      "district",
      "description",
      "age",
    ],
    "ElectricityStation": [
      "video",
      "location",
      "allow_whatsapp",
      "allow_call",
      "publish",
      "property_for",
      "street_width",
      "size",
      "front",
      "side",
      "price_sqr_meter",
      "total_price",
      "region",
      "city",
      "district",
      "description",
      "age",
    ],
    "TelecomTower": [
      "video",
      "location",
      "allow_whatsapp",
      "allow_call",
      "publish",
      "property_for",
      "street_width",
      "size",
      "front",
      "side",
      "price_sqr_meter",
      "total_price",
      "region",
      "city",
      "district",
      "description",
      "age",
    ],
    "Shop": [
      "video",
      "location",
      "is_furnished",
      "is_inside_building",
      "allow_whatsapp",
      "allow_call",
      "publish",
      "street_width",
      "size",
      "front",
      "side",
      "floor_num",
      "age",
      "price_sqr_meter",
      "total_price",
      "region",
      "city",
      "district",
      "description",
    ],
    "Booth": [
      "video",
      "location",
      "is_furnished",
      "is_inside_building",
      "allow_whatsapp",
      "allow_call",
      "publish",
      "street_width",
      "size",
      "front",
      "side",
      "floor_num",
      "age",
      "price_sqr_meter",
      "total_price",
      "region",
      "city",
      "district",
      "description",
    ],
    "RepairShop": [
      "video",
      "location",
      "is_furnished",
      "is_inside_building",
      "allow_whatsapp",
      "allow_call",
      "publish",
      "street_width",
      "size",
      "front",
      "side",
      "floor_num",
      "age",
      "price_sqr_meter",
      "total_price",
      "region",
      "city",
      "district",
      "description",
    ],
    "Office": [
      "video",
      "no_bed",
      "location",
      "is_furnished",
      "is_inside_building",
      "allow_whatsapp",
      "allow_call",
      "publish",
      "street_width",
      "size",
      "front",
      "side",
      "floor_num",
      "age",
      "price_sqr_meter",
      "total_price",
      "region",
      "city",
      "district",
      "description",
    ],
    "Warehouses": [
      "video",
      "location",
      "is_furnished",
      "allow_whatsapp",
      "allow_call",
      "publish",
      "street_width",
      "size",
      "front",
      "side",
      "floor_num",
      "age",
      "price_sqr_meter",
      "total_price",
      "region",
      "city",
      "district",
      "description",
    ],
    "Exhibition": [
      "video",
      "location",
      "is_furnished",
      "allow_whatsapp",
      "allow_call",
      "publish",
      "street_width",
      "size",
      "front",
      "side",
      "floor_num",
      "age",
      "price_sqr_meter",
      "total_price",
      "region",
      "city",
      "district",
      "description",
    ],
    "Cinema": [
      "video",
      "location",
      "is_furnished",
      "allow_whatsapp",
      "allow_call",
      "publish",
      "street_width",
      "size",
      "front",
      "side",
      "floor_num",
      "age",
      "price_sqr_meter",
      "total_price",
      "region",
      "city",
      "district",
      "description",
    ],
    "CarParking": [
      "video",
      "location",
      "is_furnished",
      "allow_whatsapp",
      "allow_call",
      "publish",
      "street_width",
      "size",
      "front",
      "side",
      "floor_num",
      "age",
      "price_sqr_meter",
      "total_price",
      "region",
      "city",
      "district",
      "description",
    ],
    "Factory": [
      "video",
      "location",
      "is_furnished",
      "allow_whatsapp",
      "allow_call",
      "publish",
      "street_width",
      "size",
      "front",
      "side",
      "floor_num",
      "age",
      "price_sqr_meter",
      "total_price",
      "region",
      "city",
      "district",
      "description",
    ],
    "Station": [
      "video",
      "location",
      "is_furnished",
      "allow_whatsapp",
      "allow_call",
      "publish",
      "street_width",
      "size",
      "front",
      "side",
      "floor_num",
      "age",
      "price_sqr_meter",
      "total_price",
      "region",
      "city",
      "district",
      "description",
    ],
  },
  ad_types: ["Rent", "Sale"],
  property_with_child: {
    Building: ["Apartment", "Shop / Office"],
    Villa: ["Apartment"],
  },
  remove_field: {
    Rent: ["total_price"],
    Sale: ["rent_type"],
    Auction: ["rent_type"],
  },
  remove_child_field: [
    "is_sewage",
    "is_water",
    "is_power",
    "is_parking",
    "is_elevator",
    "is_internal_stairs",
    "is_football_area",
    "is_volleyball_area",
    "is_amusement_area",
    "is_private_entrance",
    "is_two_entrances",
    "is_inside_villa",
    "is_inside_building",
    "location",
    "floor_num",
    "street_width",
    "is_pool",
    "is_yard",
    "no_apartment",
    "no_shop",
    "age",
    "allow_whatsapp",
    "allow_call",
    "publish",
  ],
  remove_parent_field: [
    "is_furnished",
    "is_kitchen",
    "is_rooftop",
    "is_air_conditioners",
    "is_driver_room",
    "is_maid_room",
    "is_pool",
    "is_fire_room",
    "is_yard",
    "is_basement",
    "is_duplex",
    "rent_type",
    "no_bed",
    "size",
    "front",
    "side",
    "no_living",
    "no_bath",
    "price_sqr_meter",
    "total_price",
    "no_apartment",
    "no_shop",
  ],
  rega_features: ["is_sewage", "is_water", "is_power", "is_fixed_phone","is_fiber_optics","is_flood_drainage",],
  section_features: [
    "is_sewage",
    "is_water",
    "is_power",
    "is_fixed_phone",
    "is_fiber_optics",
    "is_flood_drainage",
    "is_family",
    "is_furnished",
    "is_kitchen",
    "is_rooftop",
    "is_parking",
    "is_elevator",
    "is_air_conditioners",
    "is_internal_stairs",
    "is_driver_room",
    "is_maid_room",
    "is_pool",
    "is_fire_room",
    "is_yard",
    "is_basement",
    "is_duplex",
    "is_football_area",
    "is_volleyball_area",
    "is_amusement_area",
    "is_female_section",
    "is_private_entrance",
    "is_two_entrances",
    "is_inside_villa",
    "is_inside_building",
  ],
  section_details: [
    "street_width",
    "no_bed",
    "no_living",
    "no_bath",
    "age",
    "size",
    "front",
    "side",
    "no_apartment",
    "no_shop",
  ],
};

export class Floor {
  num = 0;
  title = "";
  children = {};
}

export class MapProperty {
  property = null;
  dirty = false;
  marker = null;
  constructor(_property = null,_dirty = null,_marker = null) {
    this.property = _property;
    this.dirty = _dirty;
    this.marker = _marker;
  }
}

export class Property {
  name = null;
  creation = null;
  property_type = "";
  ad_type = "";
  rega_data = "";
  ad_license_number = "";
  is_sewage = true;
  is_water = true;
  is_power = true;
  is_furnished = false;
  is_kitchen = false;
  is_rooftop = false;
  is_parking = false;
  is_elevator = false;
  is_air_conditioners = false;
  is_internal_stairs = false;
  is_driver_room = false;
  is_maid_room = false;
  is_pool = false;
  is_fire_room = false;
  is_yard = false;
  is_basement = false;
  is_duplex = false;
  is_football_area = false;
  is_volleyball_area = false;
  is_amusement_area = false;
  is_female_section = false;
  is_private_entrance = false;
  is_two_entrances = false;
  is_inside_villa = false;
  is_inside_building = false;
  is_fixed_phone = false;
  is_fiber_optics = false;
  is_flood_drainage = false;
  allow_whatsapp = true;
  allow_call = true;
  publish = true;
  for_type = "Both";
  is_family = false;
  rent_type = "Annually";
  property_for = "Both";
  street_width = 4;
  creator_type = "Owner";
  view_sides = [];
  no_bed = 1;
  no_apartment = 0;
  no_shop = 0;
  size = "";
  front = "";
  side = "";
  no_living = 0;
  no_bath = 0;
  floor_num = 0;
  age = 0;
  price_sqr_meter = "";
  total_price = "";
  title = "";
  // address = "";
  lat = "";
  lng = "";
  region = "";
  city = "";
  district = "";
  prv_region = "";
  prv_city = "";
  prv_district = "";
  description = "";
  // linked_images=[];
  // linked_images_names=[];
  video = null;
  images = [];
  main_image_index = 0;
  floors = []; //of object type Floor()
  errors = [];
  for_agency = 0;
  selected_agency = "";
  for_children = false;

  from_map(map_data, is_child = false) {
    if (!is_child && map_data.searchable == 0) {
      this.for_children = true;
    }
    this.name = map_data.name;
    this.rega_data = map_data.rega_data;
    this.creation = map_data.creation;
    this.property_type = map_data.property_type;
    this.ad_type = map_data.ad_type;
    this.ad_license_number = map_data.ad_license_number;
    this.is_family = map_data.is_family;
    this.is_sewage = map_data.is_sewage;
    this.is_water = map_data.is_water;
    this.is_power = map_data.is_power;
    this.is_furnished = map_data.is_furnished;
    this.is_kitchen = map_data.is_kitchen;
    this.is_rooftop = map_data.is_rooftop;
    this.is_parking = map_data.is_parking;
    this.is_elevator = map_data.is_elevator;
    this.is_fixed_phone = map_data.is_fixed_phone;
    this.is_fiber_optics = map_data.is_fiber_optics;
    this.is_flood_drainage = map_data.is_flood_drainage;
    this.is_air_conditioners = map_data.is_air_conditioners;
    this.is_internal_stairs = map_data.is_internal_stairs;
    this.is_driver_room = map_data.is_driver_room;
    this.is_maid_room = map_data.is_maid_room;
    this.is_pool = map_data.is_pool;
    this.is_fire_room = map_data.is_fire_room;
    this.is_yard = map_data.is_yard;
    this.is_basement = map_data.is_basement;
    this.is_duplex = map_data.is_duplex;
    this.is_football_area = map_data.is_football_area;
    this.is_volleyball_area = map_data.is_volleyball_area;
    this.is_amusement_area = map_data.is_amusement_area;
    this.is_female_section = map_data.is_female_section;
    this.is_private_entrance = map_data.is_private_entrance;
    this.is_two_entrances = map_data.is_two_entrances;
    this.is_inside_villa = map_data.is_inside_villa;
    this.is_inside_building = map_data.is_inside_building;
    this.allow_whatsapp = map_data.allow_whatsapp == 1 ? true : false;
    this.allow_call = map_data.allow_call == 1 ? true : false;
    this.publish = map_data.published == 1 ? true : false;
    this.rent_type = map_data.rent_type;
    this.for_type = map_data.for_type;
    this.is_family =
      this.for_type == "Family" || this.for_type == "Both" ? true : false;
    this.property_for = map_data.property_for;
    this.street_width = map_data.street_width;
    this.creator_type = map_data.creator_type;
    this.view_sides = map_data.view_sides;
    this.no_bed = map_data.no_bed;
    this.no_apartment = map_data.no_apartment;
    this.no_shop = map_data.no_shop;

    this.size = map_data.size;
    this.front = map_data.front;
    this.side = map_data.side;

    this.no_living = map_data.no_living;
    this.no_bath = map_data.no_bath;
    this.floor_num = map_data.floor_num;
    this.age = map_data.age;
    this.price_sqr_meter = map_data.price_sqr_meter;
    this.total_price = map_data.total_price;
    // this.address = "";
    this.title = map_data.title;
    this.description = map_data.description;

    this.lat = map_data.lat;
    this.lng = map_data.lng;

    // this.region = map_data.region;
    // this.city = map_data.city;
    // this.district = map_data.district;

    this.prv_region = map_data.region;
    this.prv_city = map_data.city;
    this.prv_district = map_data.district;

    this.region = "";
    this.city = "";
    this.district = "";

    this.video = map_data.video;
    this.main_image_index = 0;
    this.images = [];
    for (let index = 0; index < map_data.images.length; index++) {
      if (map_data.images[index] == map_data.image) {
        this.main_image_index = index;
      }
      this.images.push(
        new image_file({
          link: map_data.images[index],
          link_name: map_data.images_names[index],
        })
      );
    }
    this.floors = [];
    if (!is_child) {
      for (const floor_no in map_data.floors) {
        var tmp_floor = {
          children: {},
        };
        // tmp_floor.children = {};
        for (const child_property_index in map_data.floors[floor_no].children) {
          var tmp_child_property =
            map_data.floors[floor_no].children[child_property_index];
          if (
            tmp_floor.children[tmp_child_property.property_type] == undefined
          ) {
            tmp_floor.children[tmp_child_property.property_type] = [];
          }
          var tmp_property = new Property();
          tmp_property.from_map(tmp_child_property, true);
          tmp_floor.children[tmp_child_property.property_type].push(
            tmp_property
          );
        }
        this.floors.push(tmp_floor);
      }
    }
    // for (let floor_index = 0; floor_index < map_data.floors.length; floor_index++) {
    //   var data_floor = map_data.floors[floor_index];
    //   var tmp_floor = {}
    //   tmp_floor.children = {}; //of object type Floor()
    //   for (let property_type_index = 0; property_type_index < data_floor.children.property_types; property_type_index++) {
    //     var property_type_str = data_floor.children.property_types[property_type_index];
    //     var tmp_property_type = [];
    //     tmp_property_type = []
    //     for (let child_index = 0; child_index < data_floor.children.property_types[property_type_str]; child_index++) {
    //       var tmp_child = new Property();
    //       tmp_child.from_map(data_floor.children.property_types[property_type_str][child_index]);
    //       tmp_property_type[property_type_str].push(tmp_child);
    //     }
    //     tmp_floor.children[property_type_str] = ;
    //   }
    //   this.floors.push(tmp_floor);
    // }
    this.errors = [];

    this.selected_agency = "";
    this.for_agency = false;

    // var tmp_child_property = new Property();
    // tmp_child_property.from_map(this.edit_property);
  }

  optimize_images(){
    for (let index = 0; index < this.images.length; index++) {
      var image = this.images[index].data;
      var canvas=document.createElement("canvas");
      var context=canvas.getContext("2d");
      const width = 400; // set your width
      const scaleFactor = width / image.width;
      canvas.width = width;
      canvas.height = image.height * scaleFactor;
      context.drawImage(image, 0, 0, width, image.height * scaleFactor);
      var small_image = canvas.toDataURL("image/jpeg");
    }
  }

  change_location({ region_id = null, city_id = null, district_id = null }) {
    if (region_id != null) {
      this.prv_region = this.region;
      this.region = region_id;
    }
    if (city_id != null) {
      this.prv_city = this.city;
      this.city = city_id;
    }
    if (district_id != null) {
      this.prv_district = this.district;
      this.district = district_id;
    }
    this.propegate_fields();
  }

  propegate_fields() {
    for (const floor_no in this.floors) {
      for (const child_property_type in this.floors[floor_no].children) {
        for (const property_index in this.floors[floor_no].children[
          child_property_type
        ]) {
          this.floors[floor_no].children[child_property_type][
            property_index
          ].ad_type = this.ad_type;
          this.floors[floor_no].children[child_property_type][
            property_index
          ].age = this.age;
          this.floors[floor_no].children[child_property_type][
            property_index
          ].creator_type = this.creator_type;
          this.floors[floor_no].children[child_property_type][
            property_index
          ].floor_num = floor_no;
          this.floors[floor_no].children[child_property_type][
            property_index
          ].is_sewage = this.is_sewage;
          this.floors[floor_no].children[child_property_type][
            property_index
          ].is_water = this.is_water;
          this.floors[floor_no].children[child_property_type][
            property_index
          ].is_power = this.is_power;
          this.floors[floor_no].children[child_property_type][
            property_index
          ].is_elevator = this.is_elevator;
          this.floors[floor_no].children[child_property_type][
            property_index
          ].is_parking = this.is_parking;
          // this.floors[floor_no].children[child_property_type][property_index].address = this.address;
          this.floors[floor_no].children[child_property_type][
            property_index
          ].lat = this.lat;
          this.floors[floor_no].children[child_property_type][
            property_index
          ].lng = this.lng;
          this.floors[floor_no].children[child_property_type][
            property_index
          ].region = this.region;
          this.floors[floor_no].children[child_property_type][
            property_index
          ].city = this.city;
          this.floors[floor_no].children[child_property_type][
            property_index
          ].district = this.district;
          this.floors[floor_no].children[child_property_type][
            property_index
          ].allow_whatsapp = this.allow_whatsapp;
          this.floors[floor_no].children[child_property_type][
            property_index
          ].allow_call = this.allow_call;
          this.floors[floor_no].children[child_property_type][
            property_index
          ].publish = this.publish;
        }
      }
    }
    emitter.emit("update-property-form");
  }
  clone_floor(floor_index) {
    var from_floor = this.floors[floor_index];
    var new_floor = new Floor();
    // new_floor.num = this.floors.length;
    for (const property_type in from_floor.children) {
      new_floor.children[property_type] = [];
      for (const child_property in from_floor.children[property_type]) {
        var property = from_floor.children[property_type][child_property];
        var new_property_clone = Object.assign(
          Object.create(Object.getPrototypeOf(property)),
          property
        );
        new_property_clone.main_image_index = 0;
        new_property_clone.title = property.title;
        new_property_clone.images = [];
        new_floor.children[property_type].push(new_property_clone);
      }
    }
    this.floors.push(new_floor);
    this.set_floors();
    return new_floor;
  }
  move_floor(floor_index, is_up) {
    if (is_up && floor_index <= 0) return;
    if (!is_up && floor_index >= this.floors.length - 1) return;
    var move = 1;
    if (is_up) {
      move = -1;
    }
    var tmp_floor = this.floors[floor_index + move];
    // var tmp_floor_num = tmp_floor.num;
    // tmp_floor.num = this.floors[floor_index].num;
    // this.floors[floor_index].num = tmp_floor_num;
    this.floors[floor_index + move] = this.floors[floor_index];
    this.floors[floor_index] = tmp_floor;
    this.set_floors();
  }
  set_floors() {
    for (const floor_no in this.floors) {
      var selected_floor = this.floors[floor_no];
      selected_floor.num = floor_no;
      for (const property_type in selected_floor.children) {
        for (const child_property in selected_floor.children[property_type]) {
          selected_floor.children[property_type][child_property].floor_num =
            floor_no;
        }
      }
    }
  }
  delete_child_property(floor_index, property) {
    var property_type = property.property_type;
    var property_index =
      this.floors[floor_index].children[property_type].indexOf(property);
    if (property_index < 0) return;
    this.floors[floor_index].children[property_type].splice(property_index, 1);
  }
  duplicate_child_property(floor_index, property) {
    var property_type = property.property_type;
    var property_index =
      this.floors[floor_index].children[property_type].indexOf(property);
    var new_property = Object.assign(
      Object.create(Object.getPrototypeOf(property)),
      property
    );
    new_property.images = [];
    this.floors[floor_index].children[property_type].push(new_property);
  }
  add_child_property(floor_index, property_type) {
    var floor = this.floors[floor_index];
    if (floor.children[property_type] == undefined)
      floor.children[property_type] = [];
    let new_child_property = new Property();
    new_child_property.property_type = property_type;
    new_child_property.ad_type = this.ad_type;
    floor.children[property_type].push(new_child_property);
    this.propegate_fields();
    return new_child_property;
  }
  transfer_child_property(from_floor_index, to_floor_index, property) {
    var property_type = property.property_type;
    var property_index =
      this.floors[from_floor_index].children[property_type].indexOf(property);

    if (this.floors[to_floor_index].children[property_type] == undefined) {
      this.floors[to_floor_index].children[property_type] = [];
    }
    this.floors[to_floor_index].children[property_type].push(property);
    this.floors[from_floor_index].children[property_type].splice(
      property_index,
      1
    );
    property.floor_num = to_floor_index;
  }
  validate_property(property_to_test, is_child = false) {
    property_to_test.errors = [];
    // if (property_to_test.images.length == 0)
    //   property_to_test.errors.push("main_image_index");
    if (property_to_test.errors.length > 0) {
      return false;
    }
    return true;
  }
  validate() {
    var result = true;
    if (!this.validate_property(this)) {
      result = false;
    }
    return result;
  }
}

export class Mashro {
  name = null;
  creation = null;
  title = null;
  ready_made = null;
  region = null;
  city = null;
  manual_doc = null;
  manual_file = null;
  video = null;
  to_member = null;
  for_agency = null;
  contact_email = null;
  contact_no = null;
  units = null;
  price_min = null;
  price_max = null;
  area_min = null;
  area_max = null;
  electricity = 5;
  water = 5;
  logo = null;
  manual = null;
  lat = null;
  lng = null;
  location = null;
  address = null;
  details = null;
  masjid = false;
  health = false;
  shopping = false;
  park = false;
  school_male = false;
  school_female = false;
  phone = true;
  whatsapp = true;
  email = true;
  images = [];
  main_image_index = 0;
  errors = [];
  guarantees = {};
  property_types = {};

  constructor() {
    this.reset_data();
  }

  reset_data(){
    for (let index = 0; index < mashro_constants.mashro_guarantee_types.length; index++) {
      const type = mashro_constants.mashro_guarantee_types[index];
      this.guarantees[type] = 0;
    }
    for (let index = 0; index < mashro_constants.mashro_property_types.length; index++) {
      const type = mashro_constants.mashro_property_types[index];
      this.property_types[type] = false;
    }
  }

  from_map(map_data, is_edit = false) {
    if(is_edit){
      this.for_agency = map_data.user;
      this.to_member = map_data.manager_user;
    }
    this.name = map_data.name;
    this.creation = map_data.creation;
    this.title = map_data.title;
    this.owner_fullname = map_data.owner_fullname;
    this.owned = map_data.owned;
    this.managed = map_data.managed;
    this.region = map_data.region;
    this.city = map_data.city;
    this.manual_doc = map_data.manual_doc;
    this.video = map_data.video;
    this.phone = map_data.phone;
    this.whatsapp = map_data.whatsapp;
    this.email = map_data.email;
    this.contact_no = "0"+map_data.contact_no.substring(4);
    this.contact_email = map_data.contact_email;
    this.manager_user = map_data.manager_user;
    this.manager_user_fullname = map_data.manager_user_fullname;
    this.units = map_data.units;
    this.price_min = map_data.price_min;
    this.price_max = map_data.price_max;
    this.area_min = map_data.area_min;
    this.area_max = map_data.area_max;
    this.electricity = map_data.electricity;
    this.water = map_data.water;
    this.lat = map_data.lat;
    this.lng = map_data.lng;
    this.location = map_data.location;
    this.address = map_data.address;
    this.details = map_data.details;
    this.ready_made = map_data.ready_made == 1 ? true : false;
    this.masjid = map_data.masjid == 1 ? true : false;
    this.health = map_data.health == 1 ? true : false;
    this.shopping = map_data.shopping == 1 ? true : false;
    this.park = map_data.park == 1 ? true : false;
    this.school_male = map_data.school_male == 1 ? true : false;
    this.school_female = map_data.school_female == 1 ? true : false;
    // console.log(map_data.property_types);
    // console.log(map_data.guarantees);
    // console.log(this.guarantees);
    
    this.reset_data();
    for (let index = 0; index < map_data.property_types.length; index++) {
      this.property_types[map_data.property_types[index]] = true;
    }
    for (let index = 0; index < map_data.guarantees.length; index++) {
      this.guarantees[map_data.guarantees[index].type] = map_data.guarantees[index].years;
    }

    if(map_data.logo){
      this.logo = new image_file({
        link: map_data.logo,
        // link_name: map_data.images_names[index],
      })
    }
    
    this.main_image_index = 0;
    this.images = [];
    for (let index = 0; index < map_data.images.length; index++) {
      if (map_data.images[index] == map_data.image) {
        this.main_image_index = index;
      }
      this.images.push(
        new image_file({
          link: map_data.images[index],
          link_name: map_data.images_names[index],
        })
      );
    }
    this.errors = [];
  }

  optimize_images(){
    for (let index = 0; index < this.images.length; index++) {
      var image = this.images[index].data;
      var canvas=document.createElement("canvas");
      var context=canvas.getContext("2d");
      const width = 400; // set your width
      const scaleFactor = width / image.width;
      canvas.width = width;
      canvas.height = image.height * scaleFactor;
      context.drawImage(image, 0, 0, width, image.height * scaleFactor);
      var small_image = canvas.toDataURL("image/jpeg");
    }
  }
  
  validate_mashro(mashro, is_child = false) {
    mashro.errors = [];
    if (mashro.ready_made == null && !mashro.name)
      mashro.errors.push("ready_made");
    if (mashro.region == null && !mashro.name)
      mashro.errors.push("region");
    if (mashro.city == null && !mashro.name)
      mashro.errors.push("city");
    if (mashro.title == null || mashro.title.length < 3)
      mashro.errors.push("title");
    if (mashro.units == null || mashro.units.length <= 0)
      mashro.errors.push("units");
    if (mashro.price_min == null || mashro.price_min.length <= 0)
      mashro.errors.push("price_min");
    if (mashro.price_max == null || mashro.price_max.length <= 0)
      mashro.errors.push("price_max");
    if (mashro.area_min == null || mashro.area_min.length <= 0)
      mashro.errors.push("area_min");
    if (mashro.area_max == null || mashro.area_max.length <= 0)
      mashro.errors.push("area_max");
    if (mashro.images.length == 0)
      mashro.errors.push("main_image_index");
    if (mashro.address == null|| mashro.address.length < 3)
      mashro.errors.push("address");

    if (mashro.errors.length > 0) {
      return false;
    }
    return true;
  }
  validate() {
    var result = true;
    if (!this.validate_mashro(this)) {
      result = false;
    }
    return result;
  }
}

String.prototype.format = function (args) {
  let formatted = this;
  for (let i = 0; i < args.length; i++) {
    let regexp = new RegExp("\\{" + i + "\\}", "gi");
    formatted = formatted.replace(regexp, t(args[i]));
  }
  return formatted;
};

export const search_filters = {
  agency: "",
  region: "",
  city: "",
  district: "",
  ad_type: "",
  property_type: "",
  min_price: 0,
  max_price: 100,
  price: [0, 0],
  capacity: [0, 0],
  age: [1,13],
  age_min: 1,
  age_max: 13,
  no_bath: 0,
  no_bed: 0,
  published: -1,
  locked: 0,
  liked: 0,
  status: null,
  sort_by: "",
  features: {},
  location: null,
  managed: -1,
  search_str: "",
  search_type: "Property Id",
  // location: {
  //   center: [26.34269026355592, 43.950194707533655],
  //   zoom: 11,
  // },
};

search_filters.features = {};
for (
  let index = 0;
  index < property_constants.section_features.length;
  index++
) {
  search_filters.features[property_constants.section_features[index]] = false;
}

export function reset_filters(
  selected_search_filters = null,
  only_features = false
) {
  if (selected_search_filters == null) {
    selected_search_filters = search_filters;
  }
  if (!only_features) {
    selected_search_filters.agency = "";
    selected_search_filters.region = "";
    selected_search_filters.city = "";
    selected_search_filters.district = "";
    selected_search_filters.ad_type = "";
    selected_search_filters.property_type = "";
    selected_search_filters.min_price = 0;
    selected_search_filters.max_price = 100;
    selected_search_filters.price = [0, 0];
    selected_search_filters.age = [1, 13];
    selected_search_filters.capacity = [0, 0];
    selected_search_filters.no_bath = 0;
    selected_search_filters.no_bed = 0;
    selected_search_filters.published = -1;
    selected_search_filters.locked = 0;
    selected_search_filters.liked = 0;
    selected_search_filters.status = null;
    selected_search_filters.sort_by = "";
    selected_search_filters.search_str = "";
    selected_search_filters.search_type = "Property Id";
  }
  selected_search_filters.features = {};
  for (
    let index = 0;
    index < property_constants.section_features.length;
    index++
  ) {
    selected_search_filters.features[
      property_constants.section_features[index]
    ] = false;
  }
}

export function refresh_tooltips(){
  setTimeout(()=>{
      var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
      var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
          delete  tooltipTriggerEl.dataset.bsToggle
          return new bootstrap.Tooltip(tooltipTriggerEl)
      });
  }, 500);
}



export const search_projects_filters = {
  region: "",
  city: "",
  property_types: {},
};

search_projects_filters.property_types = {};
for (
  let index = 0;
  index < mashro_constants.mashro_property_types.length;
  index++
) {
  search_projects_filters.property_types[mashro_constants.mashro_property_types[index]] = false;
}
// for (let index = 0; index < mashro_constants.mashro_property_types.length; index++) {
//   const type = mashro_constants.mashro_property_types[index];
//   this.property_types[type] = false;
// }

export function reset_projects_filters(
  selected_search_projects_filters = null,
  only_features = false
) {
  if (selected_search_projects_filters == null) {
    selected_search_projects_filters = search_projects_filters;
  }
  if (!only_features) {
    selected_search_projects_filters.agency = "";
    selected_search_projects_filters.region = "";
    selected_search_projects_filters.city = "";
    selected_search_projects_filters.district = "";
    selected_search_projects_filters.ad_type = "";
    selected_search_projects_filters.property_type = "";
    selected_search_projects_filters.min_price = 0;
    selected_search_projects_filters.max_price = 100;
    selected_search_projects_filters.price = [0, 0];
    selected_search_projects_filters.age = [1, 13];
    selected_search_projects_filters.capacity = [0, 0];
    selected_search_projects_filters.no_bath = 0;
    selected_search_projects_filters.no_bed = 0;
    selected_search_projects_filters.published = -1;
    selected_search_projects_filters.locked = 0;
    selected_search_projects_filters.liked = 0;
    selected_search_projects_filters.status = null;
    selected_search_projects_filters.sort_by = "";
    selected_search_projects_filters.search_str = "";
    selected_search_projects_filters.search_type = "Property Id";
  }
  selected_search_projects_filters.features = {};
  for (
    let index = 0;
    index < mashro_constants.mashro_property_types.length;
    index++
  ) {
    search_projects_filters.property_types[mashro_constants.mashro_property_types[index]] = false;
  }
}
